import { ENV } from '../../../config/runtimeEnv';
import {
	TestType,
	ApiResponse,
	FormField
} from "../../../types/healthcare/TestTypes";
import { http } from "../../../lib/http/client";

const HEALTHCARE_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

// Get test types for a specific category
export const fetchTestTypesByCategory = async (
	category: string,
	companyId?: number
): Promise<ApiResponse<TestType[]>> => {
	const params = new URLSearchParams();
	params.append('category', category);
	if (companyId) params.append('company_id', companyId.toString());

	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types?${params.toString()}`);
	return response.data;
};

// Get a specific test type with details
export const fetchTestType = async (
	testTypeValue: string,
	companyId?: number
): Promise<ApiResponse<TestType>> => {
	const params = new URLSearchParams();
	if (companyId) params.append('company_id', companyId.toString());

	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types/${testTypeValue}?${params.toString()}`);
	return response.data;
};

// Get form configuration for a test type
export const fetchTestTypeFormConfig = async (testTypeValue: string): Promise<ApiResponse<{
	test_type: string;
	name: string;
	category: string;
	fields: FormField[];
	requirements: {
		requires_fasting: boolean;
		requires_contrast: boolean;
		specimen_types: string[] | null;
	};
	common_fields: FormField[] | null;
	specific_fields: FormField[] | null;
}>> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types/${testTypeValue}/form-config`);
	return response.data;
};

// Get test types that require fasting
export const fetchFastingRequiredTestTypes = async (): Promise<ApiResponse<TestType[]>> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types/fasting-required`);
	return response.data;
};

// Get test types that require contrast
export const fetchContrastRequiredTestTypes = async (): Promise<ApiResponse<TestType[]>> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types/contrast-required`);
	return response.data;
};

// Get test types by specimen type
export const fetchTestTypesBySpecimen = async (specimenType: string): Promise<ApiResponse<TestType[]>> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types/by-specimen?specimen_type=${specimenType}`);
	return response.data;
};

// Get popular/frequently ordered test types
export const fetchPopularTestTypes = async (
	companyId?: number,
	limit: number = 20
): Promise<ApiResponse<TestType[]>> => {
	const params = new URLSearchParams();
	if (companyId) params.append('company_id', companyId.toString());
	params.append('limit', limit.toString());

	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-types/popular?${params.toString()}`);
	return response.data;
};